import React from "react";
import { useDispatch } from "react-redux";
import {
    addCartItem,
  removeCartItem,
} from "../store/slices/cartSlice";
import { removeWishListItem } from "../store/slices/wishListSlice";

export default function WishList({
  productId,
  title,
  rating,
  price,
  imageUrl,
  quantity,
}) {
  const dispatch = useDispatch();
  return (
    <div className="cart-item-container">
      <div className="cart-item">
        <img src={imageUrl} alt={title} />
        <div>
          <h3>{title}</h3>
          <p>{rating} ★ ★ ★ ★</p>
        </div>
      </div>
      <div>
      <button
          onClick={() => {
            dispatch(removeWishListItem(productId));
          }}
        >
          Remove
        </button>
      </div>
      <div className="item-price">${price}</div>
      

      {/* <button className="addtocart"
        onClick={() => {
          dispactch(increaseCartItemQuantity(id));
        }}
      >
        Add to cart
      </button> */}
      <div className="cta-container">
          <button onClick={()=>{
            dispatch(addCartItem({ productId,title, rating, price, imageUrl }))
          }}>Add to Cart</button>
          
          </div>
    </div>
  );
}
